const nameValidate = require('./name')

module.exports = function (value) {
  return nameValidate(value, true, false, 'ADT')
}
